import { render, staticRenderFns } from "./ContributionPDF.vue?vue&type=template&id=86c6dd42&scoped=true&"
import script from "./ContributionPDF.vue?vue&type=script&lang=js&"
export * from "./ContributionPDF.vue?vue&type=script&lang=js&"
import style0 from "./ContributionPDF.vue?vue&type=style&index=0&id=86c6dd42&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c6dd42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VContainer,
  VLayout,
})
